/** Reusable surface/card sx helpers — mode-aware via portal tokens or MUI theme. */

export const getPortalCardSx = (portal, extra = {}) => ({
  borderRadius: '16px',
  bgcolor: portal.surface,
  boxShadow: portal.cardShadow,
  border: `1px solid ${portal.border}`,
  ...extra,
});

export const getAuthPageShellSx = () => ({
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  px: 2,
  py: { xs: 4, sm: 6 },
  bgcolor: 'background.default',
});

export const getAuthPageCardSx = (theme) => ({
  width: '100%',
  maxWidth: 420,
  p: { xs: 3, sm: 4 },
  borderRadius: '16px',
  bgcolor: 'background.paper',
  border: `1px solid ${theme.palette.divider}`,
  boxShadow: theme.portal?.cardShadow ?? theme.shadows[1],
});

/** Dashboard widget outer shell — use on grid cells wrapping chart/metric widgets. */
export const portalDashboardCardSx = {
  bgcolor: 'background.paper',
  borderRadius: 2,
  height: '100%',
};

/** Inner metric tile (onboarding, retention, monetisation rows). */
export const portalMetricTileSx = {
  px: 1.5,
  py: 1.35,
  borderRadius: 2,
  bgcolor: 'action.hover',
  color: 'text.primary',
};

/** Progress / funnel bar track behind colored fill. */
export const portalProgressTrackSx = {
  width: '100%',
  height: '100%',
  bgcolor: 'action.hover',
  borderRadius: 1,
};
